"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculator_service_1 = require("./calculator.service");
const clickdimensions_service_1 = require("./clickdimensions.service");
const data_service_1 = require("./data.service");
const output_service_1 = require("./output.service");
const translate_service_1 = require("./translate.service");
const storage_service_1 = require("./storage.service");
const pwa_service_1 = require("./pwa.service");
const qrcode_service_1 = require("./qrcode.service");
var State;
(function (State) {
    State["Form"] = "form";
    State["Contact"] = "contact";
    State["Results"] = "results";
    State["Export"] = "export";
})(State || (State = {}));
class FleetSavings {
    constructor() {
        this.state = State.Form;
        // Default values that can be pulled in from url
        this.country = 'GB';
        this.currencyCode = 'USD';
        this.savings = {
            idle: 100,
            optimization: 100,
            driverBehavior: 100,
            total: 300,
            carbon: 1000,
        };
        this.inputs = {
            country: null,
            fleetSize: null,
            estimatedDistance: null,
            fuelEfficiency: null,
            workDays: null,
            workDaysSlider: null,
            idleTime: null,
            fuelCostInput: null,
            fleetButton: null,
        };
        this.contactInputs = {
            first: null,
            last: null,
            email: null,
            phone: null,
            company: null,
            job: null,
            country2: null,
            referral: null,
            fleetSize: null,
            button: null,
        };
        this.translatableContent = [];
        this.resultsFromURL = false;
        this.lang = 'en';
        this.dataService = new data_service_1.DataService();
        this.translateService = new translate_service_1.TranslateService();
        this.calculatorService = new calculator_service_1.CalculatorService();
    }
    async init() {
        try {
            await this.dataService.loadData();
        }
        catch (error) {
            console.error('Unable to load data', error);
        }
        // Load all translatable items
        document.querySelectorAll('[data-i18n]').forEach((element) => {
            const key = element.textContent.trim();
            element.setAttribute('data-i18n-key', key);
            this.translatableContent.push({
                key,
                element: element,
            });
        });
        this.setupFleetForm();
        this.setupContactForm();
        this.setupGlobalStartOverButton();
        // Setup offline mode features
        if (pwa_service_1.PwaService.isOfflineMode()) {
            pwa_service_1.PwaService.setupExportTrigger(() => {
                this.state = State.Export;
                pwa_service_1.PwaService.setupExportPage();
                this.updateDisplay();
            });
            this.setupOfflineSubmission();
        }
        // Check if loading results from URL (QR code scan)
        const resultsData = qrcode_service_1.QRCodeService.decodeResultsFromURL();
        if (resultsData) {
            this.resultsFromURL = true;
        }
        // Now setup results page with correct offline mode
        this.setupResultsPage();
        const params = this.parseQueryParams();
        this.lang = params.lang;
        this.setCountry(params.countryCode);
        this.inputs.country.value = params.countryCode; // not setting in set country because of duplicate loop
        this.setLang(params.lang);
        // Set values from QR code if loaded from URL
        if (resultsData) {
            this.setValues(resultsData.calculatorData);
            this.country = resultsData.country;
            this.lang = resultsData.lang;
        }
        else {
            this.setDefaultValues();
        }
        this.updateDisplay();
    }
    setupFleetForm() {
        this.inputs.country = this.getInput('#country');
        this.inputs.fleetSize = this.getInput('#fleet-size');
        this.inputs.estimatedDistance = this.getInput('#estimated-distance');
        this.inputs.fuelEfficiency = this.getInput('#fuel-efficiency');
        this.inputs.workDays = this.getInput('#work-days');
        this.inputs.workDaysSlider = this.getInput('#work-days-slider');
        this.inputs.idleTime = this.getInput('#idle-time');
        this.inputs.fuelCostInput = this.getInput('#fuel-cost');
        this.inputs.fleetButton = this.getInput('#fcc-calculator button');
        this.inputs.workDays.addEventListener('input', () => {
            this.inputs.workDaysSlider.value = this.inputs.workDays.value;
        });
        this.inputs.workDaysSlider.addEventListener('input', () => {
            this.inputs.workDays.value = this.inputs.workDaysSlider.value;
        });
        this.inputs.country.addEventListener('change', () => {
            this.setCountry(this.inputs.country.value);
            this.setDefaultValues();
            this.updateDisplay();
        });
        this.inputs.fleetButton.addEventListener('click', () => {
            this.show(State.Contact);
        });
    }
    setupContactForm() {
        const contactForm = document.getElementById('fcc-contact');
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();
        });
        this.contactInputs.first = this.getInput('#first');
        this.contactInputs.last = this.getInput('#last');
        this.contactInputs.email = this.getInput('#email');
        this.contactInputs.phone = this.getInput('#phone');
        this.contactInputs.company = this.getInput('#company');
        this.contactInputs.job = this.getInput('#job');
        this.contactInputs.country2 = this.getInput('#country2');
        this.contactInputs.referral = this.getInput('#referral');
        this.contactInputs.fleetSize = this.getInput('#fleetSize');
        this.contactInputs.button = this.getInput('#fcc-contact button');
    }
    setupGlobalStartOverButton() {
        const globalStartOverBtn = document.getElementById('global-start-over-btn');
        if (globalStartOverBtn) {
            globalStartOverBtn.addEventListener('click', (event) => {
                event.preventDefault();
                pwa_service_1.PwaService.clearAutoResetTimer();
                this.resetApp();
            });
        }
    }
    validateContactForm() {
        const errors = [];
        // Check required fields
        if (!this.contactInputs.first.value.trim()) {
            errors.push('First Name is required');
        }
        if (!this.contactInputs.last.value.trim()) {
            errors.push('Last Name is required');
        }
        if (!this.contactInputs.email.value.trim()) {
            errors.push('Email is required');
        }
        else if (!this.contactInputs.email.value.includes('@')) {
            errors.push('Please enter a valid email address');
        }
        if (!this.contactInputs.phone.value.trim()) {
            errors.push('Phone is required');
        }
        if (!this.contactInputs.company.value.trim()) {
            errors.push('Company is required');
        }
        if (!this.contactInputs.job.value.trim()) {
            errors.push('Job Title is required');
        }
        if (this.contactInputs.country2.value === '-1' || !this.contactInputs.country2.value) {
            errors.push('Country is required');
        }
        if (this.contactInputs.referral.value === '-1' || !this.contactInputs.referral.value) {
            errors.push('Referral source is required');
        }
        const optinCheckbox = document.getElementById('optin');
        if (!optinCheckbox?.checked) {
            errors.push('You must opt in to continue');
        }
        if (errors.length > 0) {
            return 'Please fill in all required fields:\n\n• ' + errors.join('\n• ');
        }
        return null;
    }
    setupOfflineSubmission() {
        const contactForm = document.getElementById('fcc-contact');
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();
            // Validate contact form
            const validationError = this.validateContactForm();
            if (validationError) {
                pwa_service_1.PwaService.showModal(validationError, 'Missing fields');
                return;
            }
            // Collect data
            const calculatorData = this.getValues();
            const contactData = {
                first: this.contactInputs.first.value,
                last: this.contactInputs.last.value,
                email: this.contactInputs.email.value,
                phone: this.contactInputs.phone.value,
                company: this.contactInputs.company.value,
                job: this.contactInputs.job.value,
                country: this.contactInputs.country2.value,
                referral: this.contactInputs.referral.value,
                fleetSize: this.contactInputs.fleetSize.value,
                optin: document.getElementById('optin')?.checked || false,
            };
            const results = this.calculatorService.getSavings(calculatorData, this.country);
            // Save to storage
            try {
                storage_service_1.StorageService.saveSubmission({
                    calculatorData,
                    contactData,
                    results,
                });
                // Show results
                this.show(State.Results);
            }
            catch (error) {
                console.error('Error saving submission:', error);
                pwa_service_1.PwaService.showModal('Error saving submission: ' + error.message);
            }
        });
    }
    setupResultsPage() {
        const downloadButton = document.getElementById('fcc-download');
        const qrcodeContainer = document.getElementById('fcc-qrcode-container');
        const resultsSection = document.getElementById('fcc-results');
        if (pwa_service_1.PwaService.isOfflineMode() && !this.resultsFromURL) {
            // Offline mode - hide download button, show QR code
            downloadButton.style.display = 'none';
            if (qrcodeContainer) {
                qrcodeContainer.style.display = 'flex';
            }
            if (resultsSection) {
                resultsSection.classList.add('is-offline');
            }
            // Setup callback for timer and reset button - needed in offline mode
            pwa_service_1.PwaService.setupResultsPageControls(() => this.resetApp());
        }
        else if (this.resultsFromURL) {
            // Loaded from QR code - hide both download and QR code
            downloadButton.style.display = 'none';
            if (qrcodeContainer) {
                qrcodeContainer.style.display = 'none';
            }
        }
        else {
            // Online mode - show download button
            if (qrcodeContainer) {
                qrcodeContainer.style.display = 'none';
            }
            downloadButton.addEventListener('click', () => {
                output_service_1.OutputService.download('#fcc-results', 868, 748, 'Fleet Savings.pdf');
            });
        }
    }
    resetApp() {
        // Reset form inputs to default values
        this.setDefaultValues();
        // Clear contact form
        this.contactInputs.first.value = '';
        this.contactInputs.last.value = '';
        this.contactInputs.email.value = '';
        this.contactInputs.phone.value = '';
        this.contactInputs.company.value = '';
        this.contactInputs.job.value = '';
        this.contactInputs.country2.value = '-1';
        this.contactInputs.referral.value = '-1';
        const optinCheckbox = document.getElementById('optin');
        if (optinCheckbox) {
            optinCheckbox.checked = false;
        }
        // Reset to form state
        this.show(State.Form);
    }
    syncContactCountry() {
        if (!this.contactInputs.country2) {
            return;
        }
        const currentValue = this.contactInputs.country2.value;
        if (currentValue && currentValue !== '-1') {
            return;
        }
        const mappedValue = this.getContactCountryValue(this.country);
        if (mappedValue) {
            this.contactInputs.country2.value = mappedValue;
        }
    }
    setOfflineReferralDefault() {
        if (!pwa_service_1.PwaService.isOfflineMode()) {
            return;
        }
        if (!this.contactInputs.referral) {
            return;
        }
        const currentValue = this.contactInputs.referral.value;
        if (currentValue && currentValue !== '-1') {
            return;
        }
        const option = this.contactInputs.referral.querySelector('option[data-i18n-key="CONTACT_REFERRAL_EVENT"]');
        if (option) {
            this.contactInputs.referral.value = option.value;
        }
    }
    getContactCountryValue(code) {
        if (!this.contactInputs.country2) {
            return null;
        }
        const key = `COUNTRY_${code}`;
        const option = this.contactInputs.country2.querySelector(`option[data-i18n-key="${key}"]`);
        return option ? option.value : null;
    }
    parseQueryParams() {
        const params = new URLSearchParams(window.location.search);
        let countryCode = params.get('country');
        if (!countryCode) {
            countryCode = 'GB';
        }
        else if (!this.dataService.isValidCountry(countryCode)) {
            console.error('Invalid country code', countryCode);
            countryCode = 'GB';
            console.log('Expecting', this.dataService.countries.map((c) => c.value));
        }
        let lang = params.get('lang');
        if (!lang) {
            // Fallback to country specific
            switch (countryCode) {
                case 'DK': {
                    lang = 'da';
                    break;
                }
                case 'DE': {
                    lang = 'de';
                    break;
                }
                case 'BR': {
                    lang = 'pt';
                    break;
                }
                case 'ES':
                case 'MX': {
                    lang = 'es';
                    break;
                }
                case 'BE':
                case 'NL': {
                    lang = 'du';
                    break;
                }
                case 'FR': {
                    lang = 'fr';
                    break;
                }
                case 'NO': {
                    lang = 'nn';
                    break;
                }
                case 'SE': {
                    lang = 'sv';
                    break;
                }
                case 'GB': {
                    lang = 'en-gb';
                    break;
                }
                default: {
                    lang = 'en';
                }
            }
        }
        return {
            countryCode: countryCode,
            lang: lang,
        };
    }
    setLang(lang) {
        this.lang = lang;
        this.translateService.setLang(lang);
    }
    setCountry(value) {
        this.country = value;
        let units = 'metric';
        if (this.country === 'US') {
            units = 'us';
        }
        else if (this.country === 'GB') {
            units = 'gb';
        }
        if (this.country === 'GB' && (this.lang === 'en' || this.lang === 'en-gb')) {
            this.setLang('en-gb');
        }
        else if (this.country !== 'GB' && this.lang === 'en-gb') {
            this.setLang('en');
        }
        this.translateService.setUnits(units);
        this.currencyCode = this.dataService.getCurrencyCode(value);
        this.translateService.setToken('currencyCode', this.currencyCode);
    }
    setDefaultValues() {
        let estimatedDistance = 120;
        if (this.country !== 'US' && this.country !== 'GB') {
            estimatedDistance = Math.floor(estimatedDistance * calculator_service_1.KM_PER_MILE);
        }
        let fuelEfficiency = 7.8;
        if (this.country !== 'US' && this.country !== 'GB') {
            // Miles/Gallon => KM / Liter
            fuelEfficiency = fuelEfficiency * calculator_service_1.KM_PER_MILE * calculator_service_1.GALLON_PER_LITER;
            // KM/Liter => Liter/100KM
            fuelEfficiency = parseFloat((100 / fuelEfficiency).toFixed(1));
        }
        this.setValues({
            country: this.country,
            fleetSize: 3,
            estimatedDistance: estimatedDistance,
            fuelEfficiency: fuelEfficiency,
            workDays: 5,
            idleTime: 3.0,
            fuelCost: this.dataService.getFuelCost(this.country),
        });
    }
    setValues(input) {
        this.setCountry(input.country);
        this.inputs.country.value = input.country;
        this.inputs.fleetSize.value = input.fleetSize;
        this.inputs.estimatedDistance.value = input.estimatedDistance;
        this.inputs.fuelEfficiency.value = input.fuelEfficiency;
        this.inputs.workDays.value = input.workDays;
        this.inputs.workDaysSlider.value = input.workDays;
        this.inputs.idleTime.value = input.idleTime;
        this.inputs.fuelCostInput.value = input.fuelCost;
    }
    getValues() {
        const values = {
            country: this.inputs.country.value,
            fleetSize: parseFloat(this.inputs.fleetSize.value),
            estimatedDistance: parseFloat(this.inputs.estimatedDistance.value),
            fuelEfficiency: parseFloat(this.inputs.fuelEfficiency.value),
            workDays: parseFloat(this.inputs.workDays.value),
            idleTime: parseFloat(this.inputs.idleTime.value),
            fuelCost: parseFloat(this.inputs.fuelCostInput.value),
        };
        return values;
    }
    getInput(selector) {
        return document.querySelector(selector);
    }
    show(state) {
        // Clear auto-reset timer when leaving results page
        if (this.state === State.Results && state !== State.Results) {
            pwa_service_1.PwaService.clearAutoResetTimer();
        }
        this.state = state;
        if (state === State.Contact) {
            this.syncContactCountry();
            this.setOfflineReferralDefault();
        }
        this.updateDisplay();
        // Show results page in offline mode (starts timer and generates QR code)
        if (state === State.Results && pwa_service_1.PwaService.isOfflineMode() && !this.resultsFromURL) {
            const values = this.getValues();
            const savings = this.calculatorService.getSavings(values, this.country);
            pwa_service_1.PwaService.showResultsPage({
                values,
                savings,
                country: this.country,
                lang: this.lang,
            });
        }
        // Scroll to top of container
        const container = document.querySelector('.fcc-container');
        if (container) {
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    updateDisplay() {
        // Translations
        this.translatableContent.forEach((item) => {
            const translation = this.translateService.get(item.key);
            if (translation) {
                item.element.innerHTML = translation;
            }
        });
        // Update currency symbols
        const symbol = this.dataService.getCurrencySymbol(this.country);
        document.querySelectorAll('span.currency').forEach((element) => {
            element.innerHTML = symbol;
        });
        this.inputs.fuelCostInput.style.paddingLeft =
            symbol.length * 0.7 + 0.5 + 'em';
        // Update results
        if (this.state === State.Results || this.state === State.Contact) {
            // Calculate the results
            const values = this.getValues();
            const savings = this.calculatorService.getSavings(values, this.country);
            // Set the local to france to get euorpean number formatting
            const locale = this.currencyCode === 'EUR' ? 'fr' : 'en';
            const moneyFormatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: this.currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            const setMoney = (selector, value) => {
                const element = document.querySelector(selector);
                element.innerHTML = moneyFormatter.format(value);
            };
            setMoney('#result-idle', savings.idle);
            setMoney('#result-optimization', savings.optimization);
            setMoney('#result-driverBehavior', savings.driverBehavior);
            setMoney('#result-total', savings.total);
            setMoney('#preview-total', savings.total);
            const numberFormatter = new Intl.NumberFormat(locale, {
                style: 'decimal',
                currency: this.currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            document.getElementById('result-carbon').innerHTML =
                numberFormatter.format(savings.carbon);
            const setValue = (selector, value) => {
                const element = document.querySelector(selector);
                element.innerHTML = value;
            };
            setValue('#result-country', this.translateService.get(`COUNTRY_${values.country}`));
            setValue('#result-fleet-size', values.fleetSize);
            setValue('#result-estimated-distance', values.estimatedDistance);
            setValue('#result-estimated-fuel-efficiency', values.fuelEfficiency);
            setValue('#result-work-days', values.workDays);
            setValue('#result-idle-time', values.idleTime);
            setValue('#result-fuel-cost', values.fuelCost);
            // We are passing fleet size along as a hidden field
            this.contactInputs.fleetSize.value = values.fleetSize;
        }
        // Containers
        const intro = document.getElementById('fcc-intro');
        const calculator = document.getElementById('fcc-calculator');
        const contact = document.getElementById('fcc-contact');
        const results = document.getElementById('fcc-results');
        const exportPanel = document.getElementById('fcc-export');
        const resultsControls = document.getElementById('results-controls');
        if (this.state === State.Form) {
            intro.style.display = 'flex';
            calculator.style.display = 'flex';
            results.style.display = 'none';
            contact.style.display = 'none';
            if (exportPanel)
                exportPanel.style.display = 'none';
            if (resultsControls)
                resultsControls.style.display = 'none';
        }
        else if (this.state === State.Contact) {
            intro.style.display = 'none';
            calculator.style.display = 'none';
            results.style.display = 'none';
            contact.style.display = 'flex';
            if (exportPanel)
                exportPanel.style.display = 'none';
            if (resultsControls)
                resultsControls.style.display = this.resultsFromURL ? 'none' : 'flex';
        }
        else if (this.state === State.Results) {
            intro.style.display = 'none';
            calculator.style.display = 'none';
            results.style.display = 'flex';
            contact.style.display = 'none';
            if (exportPanel)
                exportPanel.style.display = 'none';
            if (resultsControls)
                resultsControls.style.display = this.resultsFromURL ? 'none' : 'flex';
        }
        else if (this.state === State.Export) {
            intro.style.display = 'none';
            calculator.style.display = 'none';
            results.style.display = 'none';
            contact.style.display = 'none';
            if (exportPanel)
                exportPanel.style.display = 'flex';
            if (resultsControls)
                resultsControls.style.display = 'none';
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    // Initialize PWA features (service worker, manifest, etc.)
    pwa_service_1.PwaService.init();
    const app = new FleetSavings();
    app.init().then(() => {
        // Show results directly from URL parameters (QR code scan)
        if (app.resultsFromURL) {
            app.show(State.Results);
            return;
        }
        if (!pwa_service_1.PwaService.isOfflineMode()) {
            // Online mode - use ClickDimensions CRM integration
            const cd = new clickdimensions_service_1.ClickDimensionsService({
                formId: 'fcc-contact',
                cdPageId: 'npnhrdifeeo6gaisdxhpg',
                debug: false,
                onError: (values) => {
                    console.error('Error submitting form', values);
                },
                beforeSubmit: () => {
                    console.log('Submitting form');
                    if (window.localStorage) {
                        window.localStorage.setItem('fcc', JSON.stringify(app.getValues()));
                    }
                },
                afterSubmit: () => {
                    console.log('Submit Complete form');
                    if (window.localStorage) {
                        try {
                            const values = JSON.parse(window.localStorage.getItem('fcc'));
                            app.setValues(values);
                            app.show(State.Results);
                        }
                        catch (e) {
                            console.error('Error loading values', e);
                        }
                    }
                },
            });
        }
    });
});
